import { errors } from 'rfc9457';
import type { z } from 'zod';
import { makeVaultRawRequest } from './make-vault-raw-request';
import { throwVaultError } from './throw-vault-error';

interface IMakeVaultValidatedRequestParams<S extends z.ZodType> {
  method: 'GET' | 'POST';
  path: string;
  body?: unknown;
  schema: S;
  baseUrl?: string;
}

export async function makeVaultValidatedRequest<S extends z.ZodType>({
  method,
  path,
  body,
  schema,
  baseUrl,
}: IMakeVaultValidatedRequestParams<S>): Promise<z.infer<S>> {
  const res = await makeVaultRawRequest({ method, path, body, baseUrl });

  if (!res.ok) {
    await throwVaultError(res);
  }

  const json: unknown = await res.json();
  const result = schema.safeParse(json);

  if (!result.success) {
    const issues = result.error.issues.map((i) => `${i.path.join('.')}: ${i.message}`).join('; ');
    throw errors.client.validation(issues);
  }

  return result.data;
}
